import { useCallback, useEffect, useState } from 'react'
import { supabase } from './supabase'

// Vetrina dei badge di un giocatore (fino a 3): scelta da lui o, se non ha scelto, i piu' rari che ha.
// Quando la modifichi dall'album, Home e album si aggiornano insieme (bumpShowcase).
const listeners = new Set()
export const bumpShowcase = () => listeners.forEach(fn => fn())

export function useShowcase(leagueId, userId) {
  const [state, setState] = useState({ items: [], custom: false, loading: true })
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick(n => n + 1), [])

  useEffect(() => {
    listeners.add(reload)
    return () => { listeners.delete(reload) }
  }, [reload])

  useEffect(() => {
    if (!leagueId || !userId) return
    let cancelled = false
    supabase.rpc('fn_badge_showcase', { p_id_league: leagueId, p_id_user: userId }).then(({ data, error }) => {
      if (cancelled) return
      if (error) setState(s => ({ ...s, loading: false }))      // la vetrina e' accessoria: in caso di errore resta quello che c'era
      else setState({ items: data ?? [], custom: !!data?.[0]?.is_custom, loading: false })
    })
    return () => { cancelled = true }
  }, [leagueId, userId, tick])

  return { ...state, reload }
}

export async function saveShowcase(leagueId, codes) {
  const { data, error } = await supabase.rpc('fn_set_badge_showcase', { p_id_league: leagueId, p_codes: codes })
  if (error || !data?.ok) return { ok: false }
  bumpShowcase()
  return { ok: true }
}
